/**
 * Hub table item attributes (DynamoDB) — use these strings for Form.Item names and API payloads
 * under products[] / services[] so the UI matches persisted schema.
 *
 * Not persisted on the item row: extraFields, fileRequired, filePlaceholder, _pendingImages.
 */
export const HUB_ITEM = {
  ItemId: "ItemId",
  ItemName: "ItemName",
  Description: "Description",
  BasePrice: "BasePrice",
  Variants: "Variants",
  Customisations: "Customisations",
  Discount: "Discount",
  ItemImages: "ItemImages",
  ItemType: "ItemType",
  RequiresPrebooking: "RequiresPrebooking",
  ItemAvailable: "ItemAvailable",
  VideoUrls: "VideoUrls",
};
